/* global Vue, AZURE_URI, LOCALE */

export default {
  name: 'AccessCode',
  template: `
<div class="access-code">
  <label for="access-code">{{ $t('accessCode.label') }}</label>

  <div class="access-code__controls">
    <input
      id="access-code"
      type="text"
      :value="internalValue"
      @input="updateValue">

    <button
      v-if="isValid && internalValue !== ''"
      class="button access-code__button"
      :title="$t('accessCode.remove')"
      @click="clearAccessCode">
      {{ $t('accessCode.remove') }}
    </button>
    <button
      v-else
      :disabled="!isDirty || internalValue == ''"
      class="button access-code__button access-code__button--confirm"
      :title="$t('accessCode.confirm')"
      @click="checkAccessCode">
      {{ $t('accessCode.confirm') }}
    </button>

  </div>

  <div
    v-show="isValid && isInfoShown"
    class="access-code__info access-code__info--valid">
    <i class="icon-check"></i>
    {{ $t('accessCode.validAccessCode') }}
  </div>

  <div
    v-show="!isValid && isInfoShown"
    class="access-code__info access-code__info--invalid">
    <i class="icon-warning"></i>
    {{ $t('accessCode.invalidAccessCode') }}
  </div>
</div>
  `,

  props: { modelValue: String },
  emits: ['update:modelValue', 'update', 'error', 'validPropertyIds'],

  setup (props, { emit }) {
    const isValid = Vue.ref(false)
    const isDirty = Vue.ref(false)
    const isInfoShown = Vue.ref(false)
    const internalValue = Vue.ref(props.modelValue)

    function updateValue (e) {
      internalValue.value = e.target.value.trim()
      isDirty.value = true
      isValid.value = false
      isInfoShown.value = false
    }

    if (internalValue.value !== '') {
      checkAccessCode()
    }

    async function checkAccessCode () {
      isDirty.value = false
      try {
        const response = await fetch(`${AZURE_URI}CheckAccessCode?accessCode=${encodeURIComponent(internalValue.value)}&locale=${LOCALE}`)
        if (!response.ok) {
          throw new Error('Error checking access code.')
        }
        const propertyIds = await response.json()
        isValid.value = propertyIds.length > 0
        if (isValid.value) {
          emit('validPropertyIds', propertyIds)
          emit('update:modelValue', internalValue.value)
          emit('update')
        }
        isInfoShown.value = true
      } catch (err) {
        emit('error', err)
        emit('validPropertyIds', [])
      }
    }

    function clearAccessCode () {
      isInfoShown.value = false
      internalValue.value = ''
      emit('update:modelValue', '')
      emit('update')
      emit('validPropertyIds', [])
    }

    return {
      isValid,
      isDirty,
      isInfoShown,
      internalValue,
      updateValue,
      checkAccessCode,
      clearAccessCode,
    }
  },
}
